export const IAUI_VERIFICATION_OPEN_DENIED_ALERT_ID = "IAUI_VERIFICATION_OPEN_DENIED_ALERT_ID";
export const IAUI_VERIFICATION_OPEN_PENDING_ALERT_ID = "IAUI_VERIFICATION_OPEN_PENDING_ALERT_ID";
